import React from 'react';
import { useTranslation } from 'react-i18next';

import { ExpandableCell } from 'modules/core/components/Table';
import { TableRow } from 'modules/core/model';
import { PurchaseIndex } from '@amzn/merp-core/models/purchase';
import { Link } from '@amzn/awsui-components-react';

interface PurchaseTableEditProps {
    row: TableRow<PurchaseIndex>;
}
export const PurchaseTableEdit = ({ row }: PurchaseTableEditProps) => {
    const { t } = useTranslation('purchase');

    const { payload } = row;
    const path =
        payload.purchaseType === 'PURCHASE_REQUEST'
            ? `/purchaseRequest/${payload.purchaseId}`
            : `/purchaseOrder/${payload.purchaseId}`;
    const url = new URL(path, window.location.origin);

    return (
        <ExpandableCell
            row={row}
            cell={
                <Link variant="secondary" href={url.href} target="_blank">
                    {t('view')}
                </Link>
            }
            content={row.payload.purchaseLines?.map(l => (
                <div key={l.lineNumber}></div>
            ))}
        />
    );
};
